/* 
// JTM - RS  
// product builder calc scripts  - Curtain Builder
*/
//waitForElm('.product.js-product > .product-info.cd-builder-ready', true).then((elm) => {

///////////////////////////////////////////////////////////
// calculate total fabric yards - Curtain and Panel Builders
//function calculateCurtainFabricYardage(inputProductWidth, inputProductLength, inputMaterialFabricWidth, inputProductQuantity, inputProductOrientation, inputGrommet, inputGrommetLocation, inputSidePocket, inputSidePocketLocation, inputSidePocketSize) {
function calculateCurtainFabricYardage(isCurtainBuilder, isPanelBuilder) {

    let value = "false";

    //if(window.console){console.log("calculateCurtainFabricYardage triggered"); }

    // product quantity
    let inputProductQuantityValue = $q("quantity-input .qty-input__input.input").val();
                
    // fabric width - input
    let inputFabricWidthValue =  $q("._cd--fabric-width input.input-text").val();
                
    // fabric design - input
    let inputFabricDesignValue =  $q("._cd--fabric-design input.input-text").val();
    
    let inputProductOrientation = 'Width';    

    ///////////

    // size width - input
    let inputProductWidthValue =  $q('._cd--width input').val();
    let inputProductWidthCheck = (parseFloat(inputProductWidthValue) !== "" && parseFloat(inputProductWidthValue) !== 0);

    // size length - input
    let inputProductLengthValue =  $q('._cd--length input').val();
    let inputProductLengthCheck = (parseFloat(inputProductLengthValue) !== "" && parseFloat(inputProductLengthValue) !== 0);


    let inputGrommet = "none";
    let inputGrommetLocation = "none";

    if (document.querySelector('._cd--product-type-grommet input[type="radio"]:checked') !== null) {
        inputGrommet = "grommet";
        inputGrommetLocation = "top";
    }

    let grommetChecked = ($q('._cd--grommets input[type="radio"]:checked') !== null);
    
    // inputProductWidth
    // inputProductLength
    // inputMaterialFabricWidth (inputFabricWidthValue)
    // inputProductQuantity (inputProductQuantityValue)
    // inputProductOrientation
    // inputGrommet
    // inputGrommetLocation

    if(isCurtainBuilder == true){

        if (grommetChecked 
            && inputProductWidthValue !== "" 
            && inputProductLengthValue !== "" 
            && inputFabricDesignValue !== "" 
            && (inputProductWidthCheck) 
            && (inputProductLengthCheck) 
            && parseFloat(inputFabricWidthValue) !== 0 
            && inputProductQuantityValue !== "" 
            && inputProductOrientation !== "" 
            && inputGrommet !== "" 
            && inputGrommetLocation !== "") 
        {
            //console.log('runCurtainPanelCalc - curtain');
            value = true;           
        }

    } else if(isPanelBuilder == true){

        let productTypeGrommetNoneChecked = ($q('._cd--product-type-none input[type="radio"][data-option-label="None"]:checked') !== null);
        let productTypeGrommetChecked = ($q('._cd--product-type-grommet input[type="radio"]:checked') !== null);
        let productTypeSidePocketChecked = ($q('._cd--product-type-side-pocket input[type="radio"]:checked') !== null);
        let productTypeSnapFastenerChecked = ($q('._cd--product-type-snap-fastener input[type="radio"]:checked') !== null);

        // panel product type attachment check - panel builder
        if (productTypeGrommetNoneChecked || productTypeGrommetChecked) { //  grommet attachment - panel builder

            let inputSidePocket = "none";
            let inputSidePocketLocation = "none";
            let inputSidePocketSize = "none";

            let productTypeGrommetNoneChecked = ($q('._cd--product-type-none input[type="radio"][data-option-label="None"]:checked') !== null);
            inputGrommet = "grommet";
            if (productTypeGrommetNoneChecked) {
                inputGrommet = "none";
                inputGrommetLocation = "none";
            }

            if (document.querySelector('._cd--grommet-location input[type="checkbox"]:checked') !== null) {

                //let grommetLocationAllFourSides = $q('._cd--grommet-location-all-four-sides input[type="checkbox"]');
                //let grommetLocationTop = $q('._cd--grommet-location-top-side input[type="checkbox"]');
                //let grommetLocationBottom = $q('._cd--grommet-location-bottom-side input[type="checkbox"]');
                //let grommetLocationLeft = $q('._cd--grommet-location-left-side input[type="checkbox"]');
                //let grommetLocationRight = $q('._cd--grommet-location-right-side input[type="checkbox"]');

                let grommetLocationAllFourSidesChecked = $q('._cd--grommet-location-all-four-sides input[type="checkbox"]').checked;
                let grommetLocationTopChecked = $q('._cd--grommet-location-top-side input[type="checkbox"]').checked;
                let grommetLocationBottomChecked = $q('._cd--grommet-location-bottom-side input[type="checkbox"]').checked;
                let grommetLocationLeftChecked = $q('._cd--grommet-location-left-side input[type="checkbox"]').checked;
                let grommetLocationRightChecked = $q('._cd--grommet-location-right-side input[type="checkbox"]').checked;

                if (grommetLocationAllFourSides.checked === true) {
                    grommetLocationAllFourSidesChecked = true;
                } else {

                    if ((grommetLocationTop.checked === true) || (self.isCurtainBuilder)) {
                        grommetLocationTopChecked = true;
                    }
                    if (grommetLocationBottom.checked === true) {
                        grommetLocationBottomChecked = true;
                    }
                    if (grommetLocationLeft.checked === true) {
                        grommetLocationLeftChecked = true;
                    }
                    if (grommetLocationRight.checked === true) {
                        grommetLocationRightChecked = true;
                    }
                }

                let grommetArray = [];

                if (grommetLocationAllFourSidesChecked === true) {
                    grommetArray.push("all-four-sides");
                } else {
                    if (grommetLocationTopChecked === true) {
                        grommetArray.push("top");
                    }
                    if (grommetLocationBottomChecked === true) {
                        grommetArray.push("bottom");
                    }
                    if (grommetLocationLeftChecked === true) {
                        grommetArray.push("left");
                    }
                    if (grommetLocationRightChecked === true) {
                        grommetArray.push("right");
                    }
                }

                inputGrommetLocation = grommetArray.join(', ');
            }

        } else if (productTypeSidePocketChecked) { // side pocket attachment - panel builder

            inputGrommet = "none";
            inputGrommetLocation = "none";

            inputSidePocket = "side-pocket";

            if (document.querySelector('._cd--side-pocket-location input[type="checkbox"]:checked') !== null) {

                //let sidePocketLocationAllFourSides = $q('._cd--side-pocket-location-all-four-sides input[type="checkbox"]');
                //let sidePocketLocationTop = $q('._cd--side-pocket-location-top input[type="checkbox"]');
                //let sidePocketLocationBottom = $q('._cd--side-pocket-location-bottom input[type="checkbox"]');
                //let sidePocketLocationLeft = $q('._cd--side-pocket-location-left input[type="checkbox"]');
                //let sidePocketLocationRight = $q('._cd--side-pocket-location-right input[type="checkbox"]');
                let sidePocketLocationAllFourSidesChecked = $q('._cd--side-pocket-location-all-four-sides input[type="checkbox"]').checked;
                let sidePocketLocationTopChecked = $q('._cd--side-pocket-location-top input[type="checkbox"]').checked;
                let sidePocketLocationBottomChecked = $q('._cd--side-pocket-location-bottom input[type="checkbox"]').checked;
                let sidePocketLocationLeftChecked =$q('._cd--side-pocket-location-left input[type="checkbox"]').checked;
                let sidePocketLocationRightChecked = $q('._cd--side-pocket-location-right input[type="checkbox"]').checked;

                if (sidePocketLocationAllFourSidesChecked === true) {
                    sidePocketLocationAllFourSidesChecked = true;
                }
                if (sidePocketLocationTopChecked === true) {
                    sidePocketLocationTopChecked = true;
                }
                if (sidePocketLocationBottomChecked === true) {
                    sidePocketLocationBottomChecked = true;
                }
                if (sidePocketLocationLeftChecked === true) {
                    sidePocketLocationLeftChecked = true;
                }
                if (sidePocketLocationRightChecked === true) {
                    sidePocketLocationRightChecked = true;
                }

                let sidePocketArray = [];

                if (sidePocketLocationAllFourSidesChecked === true) {
                    sidePocketArray.push("all-four-sides");
                } else {
                    if (sidePocketLocationTopChecked === true) {
                        sidePocketArray.push("top");
                    }
                    if (sidePocketLocationBottomChecked === true) {
                        sidePocketArray.push("bottom");
                    }
                    if (sidePocketLocationLeftChecked === true) {
                        sidePocketArray.push("left");
                    }
                    if (sidePocketLocationRightChecked === true) {
                        sidePocketArray.push("right");
                    }
                }

                inputSidePocketLocation = sidePocketArray.join(', ');
            }

            let inputSidePocketSizeDataset;
            if ((inputSidePocketSizeDataset = document.querySelector('._cd--side-pocket-size-inches input[type="radio"]:checked')) !== null) {
                inputSidePocketSizeDataset = inputSidePocketSizeDataset.data('cd-option-name');
                if (typeof inputSidePocketSizeDataset !== "undefined") {
                    inputSidePocketSize = inputSidePocketSizeDataset.replace(/\D/g, '');
                }
                //console.log("inputSidePocketSize",inputSidePocketSize);
            }
        } else if (productTypeSnapFastenerChecked) {

            inputGrommet = "none";
            inputGrommetLocation = "none";

            inputSidePocket = "none";
            inputSidePocketLocation = "none";
            inputSidePocketSize = "none";
        }

        inputProductOrientation = "length";
        
        //if(window.console){ 
            // console.log(inputGrommet, inputGrommetLocation, inputSidePocket, inputSidePocketLocation, inputSidePocketSize);
            // console.log('inputSidePocket',inputSidePocket);
            // console.log("inputProductWidthValue",inputProductWidthValue); 
            // console.log("inputProductLengthValue",inputProductLengthValue );
            // console.log("inputFabricDesignCheckedValue",inputFabricDesignCheckedValue);
            // console.log("inputProductWidthCheck",inputProductWidthCheck);
            // console.log("inputProductLengthCheck",inputProductLengthCheck);
            // console.log("inputFabricWidthValue",parseFloat(inputFabricWidthValue));
            // console.log("inputProductQuantityValue",inputProductQuantityValue);
            // console.log("inputProductOrientation",inputProductOrientation);
            // console.log("inputGrommet",inputGrommet);
            // console.log("inputGrommetLocation",inputGrommetLocation);
            // console.log("inputSidePocket",inputSidePocket);
            // console.log("inputSidePocketLocation", inputSidePocketLocation);
            // console.log("inputSidePocketSize",inputSidePocketSize);
            // console.log("window.PriceFormula.variables",window.PriceFormula.variables); 
            // console.log(inputSidePocket);
            // console.log(inputSidePocketLocation);
            // console.log(inputSidePocketSize);
        //}

        if(inputProductWidthValue !== "" 
            && inputProductLengthValue !== "" 
            && inputFabricDesignCheckedValue !== "" 
            && (inputProductWidthCheck) 
            && (inputProductLengthCheck) 
            && parseFloat(inputFabricWidthValue) !== 0 
            && inputProductQuantityValue !== "" 
            && inputProductOrientation !== "" 
            && inputGrommet !== "" 
            && inputGrommetLocation !== "" 
            && inputSidePocket !== "" 
            && inputSidePocketLocation !== "" 
            && inputSidePocketSize !== "")
        {
            //console.log('runCurtainPanelCalc - panel');
            value = true;
        }
    }

    ///////////////////////////////////////////
    // START calculation
    if(value == true){

        let yardsNeeded = 0;
        let adjustmentWidthTakeUp = 0.5;
        let adjustmentLengthTakeup = 1.01;        
        let adjustmentLengthBottomHem = 3;
        let adjustmentAccordianFold = 8.5;
        let adjustmentWidthHem = 1;
        let tableCuttingBuffer = 1;
        let grommetDropAdjustment = 1.25;
        let averageYardageDeviation = 0.0738972225;

        if ((inputProductWidthValue !== "") && (inputProductLengthValue !== "") && (inputProductQuantityValue !== "") && (inputFabricWidthValue !== "")) {
                    
            let panelWidthRanges = { 52: 1, 105: 2, 155: 3, 209: 4, 262: 5, 315: 6, 368: 7, 421: 8, 474: 9, 527: 10 };
                
            let quantity = inputProductQuantityValue;
            let fabricWidth = parseFloat(inputFabricWidthValue);
            let fabricLength = 60.00;
            let fabricYards = (fabricWidth / 36);
            let finishedWidth = parseFloat(inputProductWidthValue);
            let finishedLength = parseFloat(inputProductLengthValue);
            let orientation = inputProductOrientation;
            let numOfPlates = parseInt(quantity) * 1;
            let tiePatternWidth = 2;
            let tiePatternLength = 38.5;
            let inchesNeeded = 0;
            let adjustedWidth = ((finishedWidth + adjustmentWidthTakeUp));
            let adjustedLength = (((finishedLength * adjustmentLengthTakeup) + (adjustmentLengthBottomHem + adjustmentAccordianFold)));

            let cutWidth = (adjustedWidth + (adjustmentWidthHem * 2));
            let cutLength = adjustedLength;
            yardsNeeded = ((((cutLength + tiePatternWidth) + tableCuttingBuffer) * quantity) / 36);
            yardsNeeded = (parseInt((Math.round((yardsNeeded * 100)))) / 100);
            yardsNeeded = roundUpToNearest(yardsNeeded);
            let numCutPanels = 1;
            if (cutWidth > fabricWidth) {
                for (const [widthRange, rangeNumPanels] of Object.entries(panelWidthRanges)) {
                    if (finishedWidth <= widthRange) {
                        numCutPanels = rangeNumPanels;
                        break;
                    }
                }
                let adjustedCutWidth = (cutWidth / numCutPanels);
                adjustedCutWidth = (parseInt((Math.round((adjustedCutWidth * 100)))) / 100);
                let adjustedNumCutPanels = (quantity * numCutPanels);
                cutWidth = adjustedCutWidth;
                yardsNeeded = ((((cutLength + tiePatternWidth) + tableCuttingBuffer) * adjustedNumCutPanels) / 36);
                yardsNeeded = (parseInt((Math.round((yardsNeeded * 100)))) / 100);
                yardsNeeded = roundUpToNearest(yardsNeeded);
            }
        }

        var calculatedFabricYardsNeeded = yardsNeeded;

        //console.log(calculatedFabricYardsNeeded);

        return calculatedFabricYardsNeeded;
    } else {
        return "false";
    }
};

//}); // end wait for ready